import moment from 'moment';
import { pipe, is, ifElse, prop, evolve, identity } from 'ramda';

import config from '../../../config';

const stringifyBirthDate = ifElse(
  pipe(
    prop('birthDate'),
    is(Date),
  ),
  evolve({
    birthDate: birthDate => moment(birthDate).format(config.dateFormat),
  }),
  identity,
);

// eslint-disable-next-line import/prefer-default-export
export const prepareCustomerForSave = pipe(stringifyBirthDate);
